import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import GoldFilledSvg from "@ant-design/icons-svg/es/asn/GoldFilled";
import AntdIcon from "../components/AntdIcon";
var GoldFilled = function GoldFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GoldFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  GoldFilled.displayName = 'GoldFilled';
}
export default /*#__PURE__*/React.forwardRef(GoldFilled);